// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bie_j bie_i bie_bc bie_r bie_st","QualityCheckboxes__quality":"ex_b"};